<template>
  <div>
  </div>
</template>

<script>
  import * as turf from '@turf/turf'

  export default {
    props: ['polygon', 'active', 'google', 'map'],

    data: () => {
      return {
        googlePolygon: undefined
      }
    },

    methods: {
      checkActive() {
        this.googlePolygon.setEditable(this.active)
        this.googlePolygon.setDraggable(this.active)

        this.googlePolygon.setOptions(
          this.active
          ? { strokeOpacity: 1, fillOpacity: 0.5 }
          : { strokeOpacity: 0.25, fillOpacity: 0.1 }
        )
      }
    },

    watch: {
      active: function(value) {
        this.checkActive()
      }
    },

    activated() {
      this.googlePolygon = new this.google.maps.Polygon({
        path: this.polygon.path.map(coords => {
          return { lng: coords[0], lat: coords[1] }
        }),
        strokeColor: '#10b8a8',
        fillColor: '#10b8a8',
      })

      this.checkActive()

      const savePath = () => {
        let path = this.googlePolygon
          .getPath()
          .getArray()
          .map(point => [ point.lng(), point.lat() ])

        path.push(path[0])
        this.polygon.path = path
      }

      this.map.addListener('click', (e) => {
        if (!this.active) return

        if (this.googlePolygon.getPath().getLength() < 3) {
          this.googlePolygon.getPath().push(e.latLng)
        }

        savePath()
      })

      this.google.maps.event.addListener(this.googlePolygon.getPath(), 'insert_at', () => savePath())
      this.google.maps.event.addListener(this.googlePolygon.getPath(), 'set_at', () => savePath())
      this.google.maps.event.addListener(this.googlePolygon.getPath(), 'remove_at', () => savePath())
      this.google.maps.event.addListener(this.googlePolygon, 'dragend', () => savePath())

      this.googlePolygon.addListener('rightclick', (e) => {
        if (e.vertex && this.googlePolygon.getPath().getLength() > 3) {
          this.googlePolygon.getPath().removeAt(e.vertex)
        }
        savePath()
      })

      this.googlePolygon.setMap(this.map)
    },

    deactivated() {
      if (this.googlePolygon) {
        this.googlePolygon.setMap(null)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

